<template>
    <div class="meter-manage-main">
        <div class="meter-manage-left">
            <el-container>
                <!-- <el-main ref="elMain" style="height: calc(100vh - 140px)"> -->
                <el-main ref="elMain" style="height: calc(100vh - 10rem)">
                    <el-tree
                            class="filter-tree"
                            :data="tree"
                            :props="defaultProps"
                            :expand-on-click-node="false"
                            default-expand-all
                            :filter-node-method="filterNode"
                            ref="tree2"
                            node-key="id"
                            highlight-current
                            v-loading="loading.loading"
                            @node-click="click"
                            :indent="fontSize"

                    >

                    </el-tree>
                    <center>
                        <el-button v-show="tree.length === 0 && !loading.loading" @click="getTree">刷新</el-button>
                    </center>
                </el-main>
            </el-container>
        </div>
        <div class="meter-manage-right">
            <div style="display: flex; justify-content: center">
                <el-dialog :title="title" :visible.sync="updateDialogFormVisible" width="45%"
                           @close="resetForm('updateForm')" @open="openDialog"
                           :close-on-click-modal="false" v-if="updateDialogFormVisible">
                    <el-form :model="form" size="small" :rules="myRules" ref="updateForm" label-width="7rem">
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="仪表名称" :label-width="formLabelWidth" prop="name">
                                    <el-input v-model="form.name"
                                              @blur="form.name = form.name.replace(/\s/g,'')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="仪表编号" :label-width="formLabelWidth">
                                    <el-input v-model="form.id" disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11" v-if="checkType()">
                                <el-form-item label="表号" :label-width="formLabelWidth">
                                    <el-input v-model="form.meterNum" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11" v-if="!checkType()">
                                <el-form-item label="表号" :label-width="formLabelWidth" prop="meterNum">
                                    <el-input v-model="form.meterNum"
                                              @blur="form.meterNum = form.meterNum.replace(/\s/g,'')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="仪表型号" :label-width="formLabelWidth">
                                    <el-input v-model="form.meterTypeName" disabled></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <!-- <el-col :span="11">
                                 <el-form-item label="启用状态" :label-width="formLabelWidth" prop="enabled">
                                     <el-select v-model="form.enabled" style="width: 120px" placeholder="启用状态">
                                         <el-option label="启用" :value="1"></el-option>
                                         <el-option label="停用" :value="0"></el-option>
                                     </el-select>
                                 </el-form-item>
                             </el-col>-->
                            <el-col :span="11">
                                <el-form-item label="能源类型" :label-width="formLabelWidth">
                                    <el-input v-model="form.energyType" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item label="图标" :label-width="formLabelWidth" prop="icon">
                                    <el-select v-model="form.icon" placeholder="请选择">
                                        <el-option
                                                v-for="item in i"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>

                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--  <el-row>



                          </el-row>-->
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="安装位置" :label-width="formLabelWidth" prop="address"
                                >
                                    <el-input v-model="form.address"
                                              @blur="form.address = form.address.replace(/\s/g,'')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <el-col :span="22">
                                <!-- :maxlength="noteMaxLength"-->
                                <el-form-item label="备注" :label-width="formLabelWidth" prop="note">
                                    <el-input
                                            type="textarea"
                                            placeholder="请输入内容"
                                            v-model="form.note">
                                    </el-input>

                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-form>

                    <div slot="footer" class="dialog-footer">

                        <el-button @click="updateDialogFormVisible=false" size="small">取 消</el-button>
                        <el-button type="primary" @click="submitForm('updateForm')" :loading="loading.submiting"
                                   size="small">保 存
                        </el-button>
                    </div>
                </el-dialog>
                <el-dialog :visible.sync="deleteByEntityDialogVisible" size="small">
                    <template slot="title">删除仪表</template>
                    <div style="display: flex; justify-content: center">
                        删除仪表后数据会永久丢失！谨慎删除！
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="deleteByEntityDialogVisible = false" size="small">取消</el-button>
                        <el-button type="primary" @click="removeMeter" size="small">确认</el-button>
                    </span>
                </el-dialog>
                <el-dialog :visible.sync="configValidateDialog" width="50.5rem" :close-on-click-modal=false :show-close=false top="15vh" size="small">
                    <template slot="title">
                        批量配置仪表
                    </template>
                    <div style="display: flex; justify-content: center">
                        <el-form>
                            <div class="item-group">
                                <!--0001囤积金额、透支金额 0010报警金额 0100计费价格 1000使能跳闸-->
                                <el-checkbox v-model="configOptions['0100']" label="计费价格" border ></el-checkbox>
                                <el-checkbox v-model="configOptions['0010']" label="报警金额" border style="margin-left: 2.75rem"></el-checkbox>
                                <el-checkbox v-model="configOptions['1000']" label="使能跳闸" border style="margin-left: 2.75rem"></el-checkbox>
                                <el-checkbox v-model="configOptions['0001']" label="囤积金额、透支金额" border style="margin-left: 2.75rem"></el-checkbox>
                            </div>
                            <div class="div-hr" v-show="configOptions['0100']"></div>
                            <div class="item-group">
                                <el-form ref="rateForm" :model="operationDetail['0100']" :inline="true" size="mini" v-show="configOptions['0100']" :rules="rateRule">
                                    <el-form-item>
                                        <el-input v-model="operationDetail['0100'].operationType" value="0100" v-show=false></el-input>
                                    </el-form-item>
                                    <el-form-item label="计费价格" prop="value1">
                                        <el-select v-model="operationDetail['0100'].value1" placeholder="请选择"  style="width: 14.45rem">
                                            <el-option v-for="chargingPrice in chargingPrices" :key="chargingPrice.id" :label="chargingPrice.name" :value="chargingPrice.id"
                                                       :disabled="(disableDian & disableShui) ||
                                                        (!disableShui & disableDian ? chargingPrice.customerEnergyId === '16396ef1-06a1-4896-a3d6-6c3eb17df360' ? true : false : false) ||
                                                        (disableShui & !disableDian ? chargingPrice.customerEnergyId === '480d65f3-a47e-427c-b649-b3d179b3c0e2' ? true : false : false) ||
                                                        (disableNonPre ? chargingPrice.type === 0 ? true : false : false)
                                                        ">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-form>

                            </div>
                            <div class="div-hr" v-show="configOptions['0010']"></div>
                            <div class="item-group">
                                <el-form ref="alarmForm" :model="operationDetail['0010']" :inline="true" size="mini" v-show="configOptions['0010']" :rules="alarmRule">
                                    <el-form-item>
                                        <el-input v-model="operationDetail['0010'].operationType" value="0010" v-show=false></el-input>
                                    </el-form-item>
                                    <el-form-item label="报警金额" prop="value1">
                                        <el-input v-model="operationDetail['0010'].value1">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="div-hr" v-show="configOptions['1000']"></div>
                            <div class="item-group">
                                <el-form ref="isCutoutForm" :model="operationDetail['1000']" :inline="true" size="mini" v-show="configOptions['1000']" :rules="isCutoutRule">
                                    <el-form-item>
                                        <el-input v-model="operationDetail['1000'].operationType" value="1000" v-show=false></el-input>
                                    </el-form-item>
                                    <el-form-item label="使能跳闸" prop="value1">
                                        <el-select v-model="operationDetail['1000'].value1" placeholder="请选择" style="width: 14.45rem" :disabled="disableNonPre">
                                            <el-option label="否" :value="true"></el-option>
                                            <el-option label="是" :value="false"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div class="div-hr" v-show="configOptions['0001']"></div>
                            <div class="item-group">
                                <el-form ref="moneyForm" :model="operationDetail['0001']" :inline="true" size="mini" v-show="configOptions['0001']" :rules="moneyRule">
                                    <el-form-item>
                                        <el-input v-model="operationDetail['0001'].operationType" value="0010" v-show=false></el-input>
                                    </el-form-item>
                                    <el-form-item label="囤积金额" prop="value2">
                                        <el-input v-model="operationDetail['0001'].value2">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="透支金额" prop="value1">
                                        <el-input v-model="operationDetail['0001'].value1">
                                            <template slot="append">元</template>
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-form>

                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="configBatchCancel" size="small">取消</el-button>
                        <el-button type="primary" @click="configBatchSave" size="small">保存</el-button>
                    </span>
                </el-dialog>
            </div>
            <!--v-if="this.currentData.grade === '1'" -->
            <div class="meter-manage-condition-box">
                <el-form :inline="true" size="small" :model="condition" :disabled="conditionDisabled">

                    <el-form-item label="仪表名称">
                        <el-input placeholder="仪表名称" v-model="condition.name"
                                  size="small" class="meter-manage-condition-box-label"
                                  @blur="condition.name = condition.name.replace(/\s/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="仪表编号">
                        <el-input placeholder="仪表编号" v-model="condition.code" class="meter-manage-condition-box-label"
                                  size="small" :maxlength="inputMaxLength"
                                  @blur="condition.code = condition.code.replace(/\s/g,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="仪表型号">
                        <el-select v-model="condition.meterTypeIds" placeholder="仪表型号" @change="changeMeterTypeSelect"
                                   class="meter-manage-condition-box-label2" clearable size="small"
                                   multiple collapse-tags>
                            <el-option
                                    v-for="item in meterType"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>


                    </el-form-item>
                    <el-form-item label="能源类型">
                        <el-select v-model="condition.customerEnergyIds" placeholder="能源类型" @change="changeSelect"
                                   class="meter-manage-condition-box-label2" clearable
                                   multiple collapse-tags>
                            <el-option
                                    v-for="item in customerEnergy"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="gertList" size="small">查 找</el-button>
                    </el-form-item>

                </el-form>
            </div>
            <div style="padding-bottom: 0rem">
                <el-button type="primary" @click="checkUpdate" size="small" round
                ><i>
                    <svg-icon style="width:1em; height: 1em;" icon-class="修改"></svg-icon>
                </i>&nbsp;修改
                </el-button>
                <el-button type="primary" @click="meterDelete" size="small" round icon="el-icon-delete">删除
                </el-button>
                <el-button type="primary" @click="configValidate" size="small" round icon="el-icon-setting">批量配置</el-button>
            </div>
            <div class="div-hr"></div>
            <div class="meter-manage-table-box" v-loading="loading.dataing">

                <flex>

                    <el-table
                            :data="meter"
                            ref="meterTable"
                            stripe
                            size="small"
                            v-loading="loading.loading"
                            :header-row-style="{color:'black',height:'1px'}"
                            highlight-current-row
                            @row-click="rowClick"
                            height="100%"
                            width="100%"
                            @select="selectOne"
                            @select-all="selectAll"
                    >

                        <el-table-column type="selection"></el-table-column>
                        <el-table-column
                                align="center"
                                prop="name"
                                label="仪表名称"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="code"
                                label="仪表编号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterNum"
                                label="表号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="icon"
                                label="图标">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="meterTypeName"
                                label="仪表型号"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="energyType"
                                label="能源类型"
                                :formatter="tableStringFormat">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="address"
                                label="安装位置"
                                :formatter="tableStringFormat">
                        </el-table-column>

                        <el-table-column
                                align="center"
                                label="备注"
                                prop="note"
                                :formatter="tableStringFormat">
                        </el-table-column>
                    </el-table>

                </flex>
                <div class="customer-role-page-box">
                    <center>
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="page.current"
                                :page-sizes="[10, 20, 30, 50, 100]"
                                :page-size="page.size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="page.total"
                                align="center">
                        </el-pagination>
                    </center>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {selectMeters, selectMeterById, addMeter, list, deleteByCodes, batchSendCmd} from '@/api/Meter'
  import {checkName, checkNum, amountRegex} from '@/utils/validate'
  import {getMeterType} from '@/api/meterType'
  import {getCustomerEnergy} from '@/api/customerEnergy'
  import Flex from "../../../../components/Flex"
  import {waterMeterTypeId} from '@/config/config'
  import {mapGetters} from 'vuex'
  import { getChargingByCustomerId } from '@/api/ChargingPrice'
  import { Message } from 'element-ui'

  export default {
    name: 'meterManage',
    components: {Flex},
    watch: {
      filterText(val) {
        this.$refs.tree2.filter(val)
      }
    },
    computed: {
      ...mapGetters([
        'fontSize',
        'customerId',
        'userId'
      ])
    },
    mounted() {
      this.tree = []
      getCustomerEnergy(this.$store.getters.customerId).then(response => {
        if (response.code === 200) {
          this.customerEnergy.push({name: '全选', id: 'ALL_SELECT'})
          const data = response.infoJson
          for (let i in data) {
            if (data[i].parentId === 'host')
              this.customerEnergy.push(data[i])
          }
        } else {
          this.$message({
            type: 'error',
            message: '查询能源类型失败!',
            duration: 5 * 1000
          })
        }
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '查询能源类型失败!',
          duration: 5 * 1000
        })
      })
      getMeterType({enabled: 1}).then(response => {
        if (response.code === 200) {
          this.meterType.push({name: '全选', id: 'ALL_SELECT'})
          const data = response.infoJson
          for (let i in data)
            this.meterType.push(data[i])
        } else {
          this.$message({
            type: 'error',
            message: '查询仪表类型失败!',
            duration: 5 * 1000
          })
        }
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '查询仪表类型失败!',
          duration: 5 * 1000
        })
      })

      this.getTree()
      /* this.elMainStyle.height = parseInt(this.$refs.elMain.$el.clientHeight) * 0.95 + 'px'
       this.elMainStyle.width = (this.$refs.elMain.$el.clientWidth) + 'px'*/
      this.fetchChargingPrice()
    },
    methods: {
      configBatchCancel: function(){
        this.configOptions["0001"] = false
        this.configOptions["0010"] = false
        this.configOptions["0100"] = false
        this.configOptions["1000"] = false

        this.operationDetail = {'0001': {operationType: '0001'}, '0010': {operationType: '0010'}, '0100': {operationType: '0100'}, '1000': {operationType: '1000'}}

        this.configValidateDialog = false
      },
      configBatchSave: function(){

        let operationDetails = []
        for (let key in this.configOptions){
          if(this.configOptions[key] == true){
            let operationDetail = this.operationDetail[key]
            operationDetails.push(operationDetail)
          }
        }

        let OperationCmd = {
          meterCodes: this.meterCodes,
          customerId: this.customerId,
          operationDetails: operationDetails,
          operatorId: this.userId
        }

        let flag = true
        if (this.configOptions["0001"] === true) {
          this.$refs.moneyForm.validate(valid => {
            if (!valid) {
              Message({
                message: '囤积、透支金额配置有误!',
                type: 'warning',
                duration: 5 * 1000
              })
              flag = false
            }
          })
        }

        if (this.configOptions["1000"] === true) {
          this.$refs.isCutoutForm.validate(valid => {
            if (!valid) {
              Message({
                message: '使能跳闸配置有误!',
                type: 'warning',
                duration: 5 * 1000
              })
              flag = false
            }
          })
        }

        if (this.configOptions["0010"] === true) {
          this.$refs.alarmForm.validate(valid => {
            if (!valid) {
              Message({
                message: '报警金额配置有误!',
                type: 'warning',
                duration: 5 * 1000
              })
              flag = false
            }
          })
        }

        if (this.configOptions["0100"] === true) {
          this.$refs.rateForm.validate(valid => {
            if (!valid) {
              Message({
                message: '计费价格配置有误!',
                type: 'warning',
                duration: 5 * 1000
              })
              flag = false
            }
          })
        }

        if (flag) {
          batchSendCmd(OperationCmd).then(res => {
            let code = res.code
            if(code === 200){
              Message({
                message: res.message,
                type: 'success',
                duration: 5 * 1000
              })
            }else{
              Message({
                message: res.message,
                type: 'warning',
                duration: 5 * 1000
              })
            }
            this.configBatchCancel()
          })
        }
      },
      fetchChargingPrice: function () {//查询计费价格信息
        const condition = {customerId: this.customerId}
        getChargingByCustomerId(condition).then(res => {
          if(res.code === 200){
            this.chargingPrices =  res.infoJson
          }
        })
      },
      configValidate: function(){
        if (this.meterCodes.length == 0){
          this.$message({
            message: '请勾选需要配置的仪表!',
            type: 'warning',
            duration: 5 * 1000
          })
        }else{
          this.configValidateDialog = true
        }
      },
      selectOne: function(selection, row){

        this.disableNonPre = false
        this.disableShui = false
        this.disablePre = false
        this.disableDian = false
        let meterCodes = []
        if(selection.length > 0){
          this.currentData.clear()
          for (let meter of selection){
            this.currentData.set(meter.code,meter)
            meterCodes.push(meter.code)
            if (meter.meterTypeId === '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b' || meter.meterTypeId === '2d49e0b5-f37d-11e8-9c8f-0235d2b38928'){
              //非预付费仪表不可用
              this.disableNonPre = true
            }
            /*if (meter.meterTypeId !== '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b'){
              //非预付费仪表不可用
              this.disablePre = true
            }*/
            if (meter.customerEnergyId === '16396ef1-06a1-4896-a3d6-6c3eb17df360'){
              //水表不可用
              this.disableShui = true
            }
            if (meter.customerEnergyId === '480d65f3-a47e-427c-b649-b3d179b3c0e2'){
              //水表不可用
              this.disableDian = true
            }
          }
        }else {
          this.currentData.delete(row.code)
        }
        this.meterCodes = meterCodes
        //console.log(meterCodes)
      },
      selectAll: function(selection){
        this.disableNonPre = false
        this.disableShui = false
        this.disablePre = false
        this.disableDian = false
        let meterCodes = []
        this.currentData.clear()
        if(selection.length > 0){
          for (let meter of selection){
            this.currentData.set(meter.code,meter)
            meterCodes.push(meter.code)
            if (meter.meterTypeId === '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b' || meter.meterTypeId === '2d49e0b5-f37d-11e8-9c8f-0235d2b38928'){
              //非预付费仪表不可用
              this.disableNonPre = true
            }
            /*if (meter.meterTypeId !== '2d8c39b8-8cd1-524d-bbec-d3a3daa94f7b'){
              //非预付费仪表不可用
              this.disablePre = true
            }*/
            if (meter.customerEnergyId === '16396ef1-06a1-4896-a3d6-6c3eb17df360'){
              //水表不可用
              this.disableShui = true
            }
            if (meter.customerEnergyId === '480d65f3-a47e-427c-b649-b3d179b3c0e2'){
              //水表不可用
              this.disableDian = true
            }
          }
        }
        this.meterCodes = meterCodes
      },
      handleSelectionChange: function(val){
        console.log(val)
      },
      checkType() {
        return this.form.customerEnergyId === waterMeterTypeId
      },
      changeMeterTypeSelect(val) {
        const allValues = [];
        // 保留所有值
        for (const item of this.meterType) {
          allValues.push(item.id)
        }
        // 用来储存上一次的值，可以进行对比
        if (this.oldSearchJobType2 !== null && this.oldSearchJobType2 !== undefined && this.oldSearchJobType2.length !== 0) {
          const oldVal = this.oldSearchJobType2.length === 1 ? this.oldSearchJobType2[0] : [];
          // 取消全部选中 上次有 当前没有 表示取消全选
          if (oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) this.condition.meterTypeIds = [];
          // 点击非全部选中 需要排除全部选中 以及 当前点击的选项
          // 新老数据都有全部选中
          if (oldVal.includes('ALL_SELECT') && val.includes('ALL_SELECT')) {
            const index = val.indexOf('ALL_SELECT');
            val.splice(index, 1); // 排除全选选项
            this.condition.meterTypeIds = val
          }
          // 全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
          if (!oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
            if (val.length === allValues.length - 1) this.condition.meterTypeIds = ['ALL_SELECT'].concat(val)
          }
        }

        // 若是全部选择
        if (val.includes('ALL_SELECT')) this.condition.meterTypeIds = allValues;
        // 储存当前最后的结果 作为下次的老数据
        this.oldSearchJobType2[0] = this.condition.meterTypeIds;

      },
      changeSelect(val) {

        const allValues = [];
        // 保留所有值
        for (const item of this.customerEnergy) {
          allValues.push(item.id)
        }
        // 用来储存上一次的值，可以进行对比
        if (this.oldSearchJobType !== null && this.oldSearchJobType !== undefined && this.oldSearchJobType.length !== 0) {
          const oldVal = this.oldSearchJobType.length === 1 ? this.oldSearchJobType[0] : [];
          // 取消全部选中 上次有 当前没有 表示取消全选
          if (oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) this.condition.customerEnergyIds = [];
          // 点击非全部选中 需要排除全部选中 以及 当前点击的选项
          // 新老数据都有全部选中
          if (oldVal.includes('ALL_SELECT') && val.includes('ALL_SELECT')) {
            const index = val.indexOf('ALL_SELECT');
            val.splice(index, 1); // 排除全选选项
            this.condition.customerEnergyIds = val
          }
          // 全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
          if (!oldVal.includes('ALL_SELECT') && !val.includes('ALL_SELECT')) {
            if (val.length === allValues.length - 1) this.condition.customerEnergyIds = ['ALL_SELECT'].concat(val)
          }
        }

        // 若是全部选择
        if (val.includes('ALL_SELECT')) this.condition.customerEnergyIds = allValues;
        // 储存当前最后的结果 作为下次的老数据
        this.oldSearchJobType[0] = this.condition.customerEnergyIds;

      },
      tableStringFormat(row, column, cellValue) { // 表格中字符串格式化
        if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
          return cellValue
        }
        return '--'
      },
      handleSizeChange(size) { /* 改变条数*/
        this.meterCodes = []
        this.$refs.meterTable.clearSelection();
        this.page.size = size
        this.page.current = 1
        this.currentData.clear()
        this.list()
      },
      handleCurrentChange(val) { /* 改变页数*/
        this.currentData.clear()
        /*if(!this.myCheck(this.condition.meterTypeIds) && !this.myCheck(this.condition.customerEnergyIds))
        {
          console.log(this.condition)
          alert(1)
          this.page.current = 1
        }*/
        this.meterCodes = []
        this.$refs.meterTable.clearSelection();
        this.page.current = val
        this.list()
      },
      checkUpdate() {
        if (this.currentData.size == 1) {
          this.currentData.forEach(value => {
            this.form = value
          })
          this.updateDialogFormVisible = true
        }else {
          this.$message({
            message: '修改请选择一个仪表!',
            type: 'warning',
            duration: 5 * 1000
          })
        }

      },
      meterDelete() {
        if (this.currentData.size > 0) {
          this.deleteByEntityDialogVisible = true
        }else {
          this.$message({
            message: '请选择要删除的仪表!',
            type: 'warning',
            duration: 5 * 1000
          })
        }

      },
      removeMeter() {
        if (this.currentData.size > 0) {
          let meterCodes = []
          this.currentData.forEach(value => {
            meterCodes.push(value.code)
          })
          deleteByCodes(meterCodes).then(result => {
            if (result.code === 200) {
              this.$message({
                message: result.message,
                type: 'success',
                duration: 5 * 1000
              })
            } else {
              this.$message({
                message: result.message,
                type: 'warning',
                duration: 5 * 1000
              })
            }
            this.meterCodes = []
            this.currentData.clear()
            this.deleteByEntityDialogVisible = false
            selectMeters(this.$store.getters.customerId).then(response => {
              if (response.code === 200 && response.infoJson !== null && response.infoJson.length !== 0) {
                const data = response.infoJson
                let temp = []
                for (let i = 0; i < data.length; i++) {
                  temp.push({
                      id: data[i].id,
                      label: data[i].name,
                      code: data[i].code,
                      grade: 1,
                      children: this.getChild(data[i].meters, 1)
                    }
                  )
                }
                this.tree = temp
                this.list()
              }
              this.loading.loading = false
            })
          })
        }
        else {
          this.$message({
            message: '请选择要删除的仪表!',
            type: 'warning',
            duration: 5 * 1000
          })
        }
      },
      myCheck(...values) { /* true为空 */
        if (typeof values === undefined || values === null || values === '') return true
        let ret = true
        for (const i in values) {
          ret = typeof values[i] === undefined || values[i] === null || values[i] === ''
          if (ret === false) break
        }
        return ret
      },
      gertList() {
        this.meterCodes = []
        this.$refs.meterTable.clearSelection();
        this.currentData.clear()
        this.page.current = 1
        this.list()
      },
      list() {/*条件查询*/
        this.loading.dataing = true
        const newPage = JSON.parse(JSON.stringify(this.page))
        newPage.total = null
        const myPage = {page: newPage, condition: this.condition}
        list(myPage).then(response => {
          this.meter = []
          if (response.code === 200) {
            const data = response.infoJson
            this.page.total = data.total
            this.meter = data.records
          }
          this.currentData.clear()
          this.meterCodes = []
          this.$refs.meterTable.clearSelection();
          /*this.condition = {
            id: '',
            meterTypeName: '',
            name: '',
            customerEnergyId: ''
          }*/
          this.loading.dataing = false
        }).catch(error => {
          this.loading.dataing = false
          this.$message({
            type: 'error',
            message: '查询失败!',
            duration: 5 * 1000
          })
          this.condition = {
            customerId: this.$store.getters.customerId,
            collectionId: '',
            id: '',
            meterTypeIds: [],
            name: '',
            customerEnergyIds: []
          }
        })
      },
      cellPadding() { /* 表格间距*/
        return 'padding:0'
      },
      handleSelectionChange(val) { /* 树变化*/
        this.multipleSelection = val
      },
      filterNode(value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },
      addMeter() {
        this.loading.submiting = true

        addMeter({
          name: this.form.name,
          id: this.form.id,
          note: this.form.note,
          address: this.form.address,
          enabled: this.form.enabled,
          icon: this.form.icon,
          meterNum: this.form.meterNum
        }).then(response => {
          if (response.code === 200 && response.infoJson === true) {
            this.success()
          }
          else {
            this.$message({
              type: 'error',
              message: '修改失败!',
              duration: 5 * 1000
            })
          }

          this.currentData.clear()
          this.meterCodes = []
          /*if (this.page.total) this.page.total = null
          const myPage = {page: this.page, condition: {customerId: this.$store.getters.customerId, id: this.currentData.id}}
          */
          this.loading.submiting = false
          this.meter = []
          this.tree = []
          selectMeters(this.$store.getters.customerId).then(response => {
            if (response.code === 200 && response.infoJson !== null && response.infoJson.length !== 0) {
              const data = response.infoJson
              for (let i = 0; i < data.length; i++) {
                this.tree.push({
                    id: data[i].id,
                    label: data[i].name,
                    code: data[i].code,
                    grade: 1,
                    children: this.getChild(data[i].meters, 1)
                  }
                )
              }
              this.list()
            }
            this.loading.loading = false
          }).catch(error => {
            this.$message({
              type: 'error',
              message: '查询失败!',
              duration: 5 * 1000
            })

            this.loading.loading = false
          })

          this.dialogFormVisible = false
          this.updateDialogFormVisible = false
        }).catch(error => {
          this.loading.submiting = false
          this.dialogFormVisible = false
          this.updateDialogFormVisible = false
        })
      },
      click(data) { /* 树点击事件*/
        this.loading.dataing = true
        this.currentData.clear()
        // 集中器
        if (data.grade === 1) {
          // this.condition.customerId = ''
          this.condition.id = ''
          this.conditionDisabled = false
          this.condition.collectionId = data.id
        } else {// 仪表
          this.condition = {
            customerId: this.$store.getters.customerId,
            collectionId: '',
            id: '',
            meterTypeIds: [],
            name: '',
            customerEnergyIds: []
          }
          this.condition.id = data.id
          this.conditionDisabled = true
        }
        this.page.current = 1
        const newPage = JSON.parse(JSON.stringify(this.page))
        newPage.total = null
        const myPage = {page: newPage, condition: this.condition}
        this.meter = []
        list(myPage).then(response => {
          if (response.code === 200) {
            if (response.infoJson.records !== null && response.infoJson.records.length !== 0) {
              const rsData = response.infoJson
              this.meter = rsData.records
              this.page.total = rsData.total
              /*if (data.grade !== 1) {
                this.currentData = this.meter[0]
                this.currentData.grade = 10
                this.form = this.meter[0]
              }*/
            }
          }
          else {
            this.$message({
              type: 'error',
              message: '查询失败!',
              duration: 5 * 1000
            })
          }
          this.loading.dataing = false
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询失败!',
            duration: 5 * 1000
          })
          this.loading.dataing = false
        })
      },
      selectMeterById(myPage) {
        selectMeterById(myPage).then(response => {
          if (response.code === 200) {
            if (response.infoJson.records !== null && response.infoJson.records.length !== 0) {
              const data = response.infoJson
              this.meter = data.records

              this.page.total = data.total
              // this.page.current = data.current
              // this.page.size = data.size
              // this.page.pages = data.pages
              if (data.grade !== 1) {

                this.form.name = this.meter[0].name
                this.form.id = this.meter[0].id
                this.form.code = this.meter[0].code
                this.form.enabled = this.meter[0].enabled
                this.form.icon = this.meter[0].icon
                this.form.address = this.meter[0].address
                this.form.collectionId = this.meter[0].collectionId
                this.form.note = this.meter[0].note
                this.form.customerEnergyName = this.meter[0].customerEnergyName
                this.form.meterNum = this.meter[0].meterNum
                this.form.meterTypeName = this.meter[0].meterTypeName
              }
            }

          }
          else {
            this.$message({
              type: 'error',
              message: '查询仪表失败!',
              duration: 5 * 1000
            })
          }

        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询仪表失败!',
            duration: 5 * 1000
          })
        })
      },
      rowClick(row) { /* table行点击事件*/

        this.$refs.tree2.setCurrentKey(row.id)

        if (row) {
          this.$refs.meterTable.toggleRowSelection(row);
          if(this.meterCodes.indexOf(row.code) > -1){
            this.meterCodes.splice(this.meterCodes.indexOf(row.code),1)
          }else{
            this.meterCodes.push(row.code)
          }
          if(this.currentData.has(row.code)){
            this.currentData.delete(row.code)
          }else {
            this.currentData.set(row.code,row)
          }
        } else {
          this.$refs.meterTable.clearSelection();
        }
      },
      success() { /* 成功提示*/
        this.$message({
          type: 'success',
          message: '修改成功!',
          duration: 5 * 1000
        })
      },
      getTree() {
        this.loading.loading = true
        this.meter = []
        this.tree = []
        this.form.collectionId = ''
        selectMeters(this.$store.getters.customerId).then(response => {
          if (response.code === 200 && response.infoJson !== null && response.infoJson.length !== 0) {
            const data = response.infoJson
            for (let i = 0; i < data.length; i++) {
              this.tree.push({
                  id: data[i].id,
                  label: data[i].name,
                  code: data[i].code,
                  grade: 1,
                  children: this.getChild(data[i].meters, 1)
                }
              )
            }
            this.condition.collectionId = this.tree[0].id
            this.currentKey = this.tree[0].id
            this.$nextTick(() => {
              this.$refs.tree2.setCurrentKey(this.tree[0].id)
            })
            this.list()
          }
          this.loading.loading = false
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '查询失败!',
            duration: 5 * 1000
          })

          this.loading.loading = false
        })
      },
      getChild(meters, grade) { /* 子节点*/
        const children = []
        for (let j = 0; j < meters.length; j++) {
          if (!this.myCheck(meters[j])) {
            children.push(
              {
                id: meters[j].id,
                code: meters[j].code,
                label: meters[j].name,
                grade: parseInt(grade + 1)
              }
            )
          }
        }
        return children
      },
      submitForm(formName) { /* 表单验证*/
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addMeter()
          } else {
            return false
          }
        })
      },
      openDialog() {
        this.loading.submiting = false
      },
      resetForm(formName) { /* 移除表单检验结果*/
        this.$refs[formName].clearValidate()
      }
    },
    data() {
      var validateOverdraftAmount = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('透支金额必填'))
        } else {
          if(!amountRegex.test(value)){
            callback(new Error("请输入正确的金额"))
          }else{
            if (this.operationDetail['0001'].value2 === '') {
              callback(new Error('囤积金额必填'))
            }else{
              if(parseFloat(value) > parseFloat(this.operationDetail['0001'].value2)){
                callback(new Error('透支金额不能大于可囤积金额'))
              }else{
                callback()
              }
            }
          }
        }
      }
      return {
        oldSearchJobType: [],
        oldSearchJobType2: [],
        conditionDisabled: false,
        customerEnergy: [], /* 能源类型 */
        meterType: []/*仪表类型*/,
        input: '',
        filterText: '',
        tree: [], /* 树*/
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        i: [
          {value: '1', label: '图标1'},
          {value: '2', label: '图标2'}
        ],
        loading: {
          loading: false,
          submiting: false,
          dataing: false
        }, /* 加载*/
        meter: [], /* 仪表信息*/
        select: [],
        multipleSelection: '',
        dialogTableVisible: false,
        dialogFormVisible: false,
        updateDialogFormVisible: false,
        deleteByEntityDialogVisible: false,
        elMainStyle: {
          height: '',
          width: ''
        },
        inputMaxLength: 50,
        noteMaxLength: 50,
        currentKey: '',
        form: {
          id: '',
          name: '',
          code: '',
          enabled: 1,
          icon: '',
          note: '',
          collectionId: '',
          address: '',
          customerEnergyName: '',
          meterTypeName: '',
          customerEnergyId: '',
          meterNum: '',
          meterTypeId: '',
          energyType: ''
        },
        formLabelWidth: '7rem',
        title: '修改仪表',
        condition: {
          code: '',
          customerId: this.$store.getters.customerId,
          collectionId: '',
          id: '',
          meterTypeIds: [],
          name: '',
          customerEnergyIds: []
        },
        page: {
          size: 10,
          current: 1,
          total: 0
        }, /* 分页查询*/
        currentData: new Map(),
        myRules: {
          /* 正则*/
          meterNum: [{required: true, message: '表号不能为空'}, {validator: checkNum, trigger: 'change'}],
          name: [
            {required: true, message: '仪表名称不能为空'}, {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'change'}
          ],
          code: [
            {required: true, message: '仪表代码不能为空'}
          ],
          enabled: [
            {required: true, message: '请选择是否启用', trigger: 'change'}
          ],
          icon: [
            {required: true, message: '请选择图标', trigger: 'change'}
          ],
          address: [
            {required: true, message: '请填写地址信息'},
            /*{validator: checkName, trigger: 'blur'},*/
            {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'}
          ],
          note: [
            {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'change'}
          ]

        },
        meterCodes: [],
        configValidateDialog: false,
        configOptions: {
          '0001': false,
          '0010': false,
          '0100': false,
          '1000': false
        },
        operationDetail: {
          '0001': {
            operationType: '0001'
          },
          '0010': {
            operationType: '0010'
          },
          '0100': {
            operationType: '0100'
          },
          '1000': {
            operationType: '1000'
          }
        },
        chargingPrices: [],
        disableNonPre: false,
        disablePre: false,
        disableShui: false,
        disableDian: false,
        alarmRule: {
          value1: [{ required: true, message: '报警金额必填', trigger: 'blur' }, { pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' },{ min: 0, max: 999999.99, message: '请输入正确的金额', trigger: 'blur' }],
        },
        isCutoutRule: {
          value1: { required: true, message: '使能欠费跳闸必选'}
        },
        moneyRule: {
          value1: [{ validator: validateOverdraftAmount, trigger: 'blur' },{ required: true, message: '透支金额必填', trigger: 'blur' },{ pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' },{ min: 0, max: 999999.99, message: '请输入正确的金额', trigger: 'blur' }],
          value2: [{ required: true, message: '囤积金额必填', trigger: 'blur' }, { pattern: amountRegex, message: '请输入正确的金额', trigger: 'blur' },{ min: 0, max: 999999.99, message: '请输入正确的金额', trigger: 'blur' }],
        },
        rateRule: {
          value1: { required: true, message: '计费价格必选'}
        },
      }
    }
  }
</script>
<style scoped rel="stylesheet/scss" lang="scss">

    .meter-manage-main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        box-sizing: border-box;
        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }
        .meter-manage-left {
            display: flex;
            width: 16%;
            .el-tree {
                background-color: #fafafa;
                min-width: 100%;
                display: inline-block !important;
                .el-tree-node__label {
                    font-size: 14px;
                }
                /*background: rgba(244, 248, 249, 0.47);*/
            }

            /*  .el-main {
                  padding: 0.5rem;
              }*/
        }
        .div-hr {
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
            height: 0.1rem;
            background-color: #dedede;
        }
        .meter-manage-right {
            padding-left: 1rem;
            width: calc(84% - 1rem);
            display: flex;
            flex-direction: column;
            /*flex: 4;*/
            .meter-manage-table-box {
                height: calc(100vh - 18.45rem);
                width: calc(100% - 0.6rem);
                /*.meter-manage-page-box {
                    height: 45px;
                    display: flex;

                    justify-content: center;
                    align-items: center;
                }*/
            }
            .meter-manage-condition-box {
                font-size: 14px;
                height: 3.75rem;
                display: flex;
                align-items: center;
                padding-top: 0.5rem;
                box-sizing: border-box;
                .meter-manage-condition-box-label {
                    width: 120px;
                }
                .meter-manage-condition-box-label2 {
                    width: 190px;
                }
                /*.meter-manage-search-button {
                    margin-left: 10px;
                }*/
                button {
                    margin-left: 0.5rem;
                }
            }

        }

        .el-table th {
            background-color: #f5fafb;
        }
    }

    /*::-webkit-scrollbar { !*滚动条整体样式*!
        width: 6px; !*高宽分别对应横竖滚动条的尺寸*!
        height: 6px;
    }

    ::-webkit-scrollbar-thumb { !*滚动条里面小方块*!
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(210, 210, 210, 210);
        background: rgba(210, 210, 210, 210);
    }

    ::-webkit-scrollbar-track { !*滚动条里面轨道*!
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 255);
        border-radius: 0;
        background: rgba(255, 255, 255, 255);
    }*/
</style>
<!--
<style>
    .meter-manage-main .el-dialog__body {
        border-top: 1px solid #dedede;
        border-bottom: 1px solid #dedede;
    }

</style>-->
